var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclamationTriangle = function SvgExclamationTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.233 14.325 9.708.911a.817.817 0 0 0-1.417 0L.768 14.325a.78.78 0 0 0-.1.382.8.8 0 0 0 .808.793h15.05a.82.82 0 0 0 .39-.098.785.785 0 0 0 .318-1.077Zm-14.39-.41L9 2.937l6.158 10.978H2.842Zm5.349-2.378c0-.438.355-.793.792-.793h.032a.793.793 0 1 1 0 1.586h-.032a.793.793 0 0 1-.792-.793ZM9 6.781a.808.808 0 0 0-.808.809v1.554a.808.808 0 0 0 1.617 0V7.59A.808.808 0 0 0 9 6.782Z",
    fill: "#040404"
  })));
};
export default SvgExclamationTriangle;